module.exports = __webpack_public_path__ + "img/pålestikk_tredd_4.8940c794.jpg";